import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import { UserForm } from "../../components";
import { Card, Col, Row, Spin } from "antd";

const EditView = (props: any) => {
    const { userData, onFinish, onFinishFailed } = props;

    return (
        <Layout
            titles={[
                { name: "Users", link: "/user" },
                { name: "Edit", link: "" },
                { name: userData?.name, link: "" },
            ]}
        >
            <MetaTag title="Add User" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"User Update"}
                        bordered={true}
                    >
                        {userData && (
                            <UserForm
                                user={userData}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default EditView;
